export class RegistroPagoParamsModel {
	pago: string
	nombre_beneficiario: string
	nombre_banco: string
	email_beneficiario: string
	numero_cuenta: string
	monto_pago: number
	page_number: number
}
